import { useEffect, useState } from 'react';

// Wait until the component is mounted to rehydrate.
// In our case we force to rehydrate by changing the key with `clienOnly`, but we can also return null when is not mounted
// See: https://www.joshwcomeau.com/react/the-perils-of-rehydration/
export function useClient() {
	const [clientOnly, setClientOnly] = useState(false);
	useEffect(() => {
		setClientOnly(true);
	}, []);
	return clientOnly;
}
